import * as types from './types';

export const state = {
  commentList: [],
  setActiveComment: {},
};

export const mutations = {
  [types.SET_COMMENT_LIST](state, comments) {
    state.commentList = comments;
  },
  [types.SET_ACTIVE_COMMENT](state, comment) {
    state.activeComment = { ...comment };
  },
  [types.RESET_ACTIVE_COMMENT](state) {
    state.activeComment = {};
  },
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Comments/store/mutations.js